/**
 * Identificadores de los vídeos de youtube
 */
export enum YOUTUBE_VIDEO {
  CREATE_EVENTS = 'create-events',
  CREATE_CAMPAIGNS_OFFERS = 'create-campaigns-offers',
  ADD_OFFER_PROVIDER = 'add-offer-provider',
  SEGMENTATION_FILTER = 'segmentation-filter',
  REPORTING = 'reporting',
}
